import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { SuccessSwal, ErrorSwal } from '@shared/helpers/swal';

const EmpresaCreateModal = ({ show, onHide, onCreate, loading, tiposDocumento, loadingTipos }) => {
  console.log('EmpresaCreateModal renderizado - show:', show, 'tiposDocumento:', tiposDocumento);
  
  const initialForm = {
    razonSocial: '',
    rut: '',
    sigla: '',
    direccion: '',
    contactoComercial: '',
    telefonoComercial: '',
    emailComercial: '',
    jefeFlota: '',
    telefonoJf: '',
    emailJf: '',
    tipo_documento_id: '',
    is_forced: false
  };

  const [form, setForm] = useState(initialForm);

  // Limpiar formulario cuando se abre el modal
  useEffect(() => {
    if (show) {
      console.log('Limpiando formulario');
      setForm(initialForm);
    }
  }, [show]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const result = await onCreate(form);
      
      if (result && result.success) {
        // Limpiar formulario
        setForm(initialForm);
        // Mostrar éxito y cerrar modal
        SuccessSwal('Éxito', 'Empresa creada correctamente');
        onHide();
      } else {
        // Mostrar error
        ErrorSwal('Error', result?.error || 'Error al crear la empresa');
      }
    } catch (error) {
      console.error('Error al crear empresa:', error);
      ErrorSwal('Error', 'Error inesperado al crear la empresa');
    }
  };

  return (
    <>
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Crear Empresa</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <div className="mb-4">
            <h5 className="mb-3">Información Empresa y Contacto Comercial</h5>
            <Row>
              <Col md={4}>
                <Form.Group className="mb-2" style={{ minHeight: '65px' }}>
                  <Form.Label>Razón Social</Form.Label>
                  <Form.Control name="razonSocial" value={form.razonSocial} onChange={handleChange} required size="sm" />
                </Form.Group>
                <Form.Group className="mb-2" style={{ minHeight: '65px' }}>
                  <Form.Label>Rut</Form.Label>
                  <Form.Control name="rut" value={form.rut} onChange={handleChange} required size="sm" />
                </Form.Group>
                <Form.Group className="mb-2" style={{ minHeight: '65px' }}>
                  <Form.Label>Sigla</Form.Label>
                  <Form.Control name="sigla" value={form.sigla} onChange={handleChange} required size="sm" />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-2" style={{ minHeight: '65px' }}>
                  <Form.Label>Contacto Comercial</Form.Label>
                  <Form.Control name="contactoComercial" value={form.contactoComercial} onChange={handleChange} size="sm" />
                </Form.Group>
                <Form.Group className="mb-2" style={{ minHeight: '65px' }}>
                  <Form.Label>Teléfono Comercial</Form.Label>
                  <Form.Control name="telefonoComercial" value={form.telefonoComercial} onChange={handleChange} size="sm" />
                </Form.Group>
                <Form.Group className="mb-2" style={{ minHeight: '65px' }}>
                  <Form.Label>Email Comercial</Form.Label>
                  <Form.Control name="emailComercial" value={form.emailComercial} onChange={handleChange} size="sm" />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-2" style={{ minHeight: '65px' }}>
                  <Form.Label>Tipo Documento</Form.Label>
                  <Form.Select 
                    name="tipo_documento_id" 
                    value={form.tipo_documento_id} 
                    onChange={handleChange} 
                    required 
                    size="sm"
                    disabled={loadingTipos}
                  >
                    <option value="">
                      {loadingTipos ? 'Cargando...' : 'Seleccionar tipo de documento'}
                    </option>
                    {tiposDocumento?.map((tipo) => (
                      <option key={tipo.id} value={tipo.id}>
                        {tipo.documento}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-2" style={{ minHeight: '65px' }}>
                  <Form.Label>Dirección</Form.Label>
                  <Form.Control name="direccion" value={form.direccion} onChange={handleChange} size="sm" />
                </Form.Group>
                <Form.Group className="mb-2" style={{ minHeight: '65px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                  <Form.Label>Forzar creación</Form.Label>
                  <div style={{ display: 'flex', alignItems: 'center', height: '31px' }}>
                    <Form.Check name="is_forced" checked={form.is_forced} onChange={handleChange} label="Forzar" />
                  </div>
                </Form.Group>
              </Col>
            </Row>
          </div>
          <div>
            <h5 className="mb-3">Información del Jefe de Flota</h5>
            <Row>
              <Col md={4}>
                <Form.Group className="mb-2" style={{ minHeight: '65px' }}>
                  <Form.Label>Jefe Flota</Form.Label>
                  <Form.Control name="jefeFlota" value={form.jefeFlota} onChange={handleChange} size="sm" />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-2" style={{ minHeight: '65px' }}>
                  <Form.Label>Teléfono Jefe Flota</Form.Label>
                  <Form.Control name="telefonoJf" value={form.telefonoJf} onChange={handleChange} size="sm" />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-2" style={{ minHeight: '65px' }}>
                  <Form.Label>Email Jefe Flota</Form.Label>
                  <Form.Control name="emailJf" value={form.emailJf} onChange={handleChange} size="sm" />
                </Form.Group>
              </Col>
            </Row>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancelar</Button>
        <Button variant="primary" type="submit" onClick={handleSubmit} disabled={loading}>
          {loading ? 'Creando...' : 'Crear Empresa'}
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  );
};

EmpresaCreateModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  tiposDocumento: PropTypes.array,
  loadingTipos: PropTypes.bool,
};

export default EmpresaCreateModal;
